// extracted by mini-css-extract-plugin
export var errorIcon = "_kj-1";
export var nameLogo = "_kj-0";